import { render, staticRenderFns } from "./rolesDialog.vue?vue&type=template&id=497e02f8&scoped=true&"
import script from "./rolesDialog.vue?vue&type=script&lang=js&"
export * from "./rolesDialog.vue?vue&type=script&lang=js&"
import style0 from "./rolesDialog.vue?vue&type=style&index=0&id=497e02f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e02f8",
  null
  
)

export default component.exports